import {z} from 'zod';

export const bulkVatChangeFormSchema = z.object({
  vatType: z.string(),
});

export type BulkVatChangeFormType = z.infer<typeof bulkVatChangeFormSchema>;
